import { Loader } from "@googlemaps/js-api-loader";
import Tabs from "../modules/tabs";
import Rent from "../partials/template-rent";

const GoogleMap = {
  polygons: {},
  activePolygon: null,
  activeStyle: {
    strokeWeight: 2,
    strokeColor: "#D70040",
  },
  markers: [],

  library: null,
  renderer: {
    render: function ({ count, position }, stats) {
      // create svg url with fill color
      const svg = window.btoa(`
			<svg fill="#242538" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
			  <circle cx="120" cy="120" opacity=".6" r="70" />
			  <circle cx="120" cy="120" opacity=".3" r="90" />
			  <circle cx="120" cy="120" opacity=".2" r="110" />
			</svg>`);
      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(35, 35),
        },
        label: {
          text: String(count),
          color: "#fff",
          fontSize: "12px",
        },
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  },

  /**
   * Create google map
   */
  create(data, mapEl) {
    if (!GoogleMap.library) {
      const loader = new Loader({
        apiKey: google_api_key,
        version: "weekly",
        libraries: ["geometry", "places"],
        language: "lv",
        region: "LV",
      });

      loader.load().then((google) => {
        GoogleMap.library = google.maps;
        GoogleMap.createMap(data, mapEl, google);
      });
    } else {
      GoogleMap.createMap(data, mapEl);
    }
  },

  createMap(data, mapEl) {
    const pos = {
      lat: data.lat,
      lng: data.lng,
    };

    const map_options = {
      zoom: data.zoom,
      center: pos,
      disableDefaultUI: true,
      zoomControl: true,
      styles: GoogleMap.styles,
    };

    const map = new GoogleMap.library.Map(mapEl[0], map_options);

    map.markers = [];

    // Add markers for each location
    const locations = [
      { lat: 56.9383487, lng: 24.2149527, name: "a" },
      { lat: 56.892359, lng: 24.1283202, name: "b" },
      { lat: 56.96478, lng: 24.4783096, name: "b" },
      { lat: 56.9566585, lng: 23.9354797, name: "c" },
      { lat: 56.9458273, lng: 23.6848119, name: "d" },
      { lat: 56.7477578, lng: 24.2603223, name: "d" },
      { lat: 56.8145393, lng: 23.7446502, name: "e" },
      { lat: 57.117349, lng: 24.2687718, name: "e" },
    ];

    locations.forEach((location) => {
      const marker = GoogleMap.addMarker(location, map, location.name);
      map.markers.push(marker);
    });

    GoogleMap.markers = map.markers;

    const regionA = [
      new google.maps.LatLng(56.851383, 24.272871),
      new google.maps.LatLng(56.85448, 24.278536),
      new google.maps.LatLng(56.855653, 24.287205),
      new google.maps.LatLng(56.857108, 24.309006),
      new google.maps.LatLng(56.854014, 24.319853),
      new google.maps.LatLng(56.850072, 24.32775),
      new google.maps.LatLng(56.846129, 24.346632),
      new google.maps.LatLng(56.843688, 24.369635),
      new google.maps.LatLng(56.842749, 24.389548),
      new google.maps.LatLng(56.852325, 24.400191),
      new google.maps.LatLng(56.865839, 24.406714),
      new google.maps.LatLng(56.90691, 24.406371),
      new google.maps.LatLng(56.921154, 24.393668),
      new google.maps.LatLng(56.952434, 24.377188),
      new google.maps.LatLng(56.958799, 24.377875),
      new google.maps.LatLng(56.965451, 24.365942),
      new google.maps.LatLng(56.972001, 24.343969),
      new google.maps.LatLng(56.987529, 24.316503),
      new google.maps.LatLng(56.996506, 24.30792),
      new google.maps.LatLng(57.009221, 24.30895),
      new google.maps.LatLng(57.001075, 24.279327),
      new google.maps.LatLng(56.992847, 24.252548),
      new google.maps.LatLng(56.996213, 24.245682),
      new google.maps.LatLng(56.995652, 24.230919),
      new google.maps.LatLng(56.998831, 24.219246),
      new google.maps.LatLng(56.996026, 24.196243),
      new google.maps.LatLng(56.998083, 24.175301),
      new google.maps.LatLng(57.002384, 24.17839),
      new google.maps.LatLng(57.007058, 24.173584),
      new google.maps.LatLng(57.010423, 24.161224),
      new google.maps.LatLng(57.017339, 24.160881),
      new google.maps.LatLng(57.025562, 24.154014),
      new google.maps.LatLng(57.033035, 24.137878),
      new google.maps.LatLng(57.024067, 24.122772),
      new google.maps.LatLng(57.023319, 24.113159),
      new google.maps.LatLng(57.029579, 24.089182),
      new google.maps.LatLng(57.028131, 24.086436),
      new google.maps.LatLng(57.015563, 24.090384),
      new google.maps.LatLng(57.000396, 24.090993),
      new google.maps.LatLng(56.974577, 24.088207),
      new google.maps.LatLng(56.96625, 24.087005),
      new google.maps.LatLng(56.945549, 24.099794),
      new google.maps.LatLng(56.938221, 24.117755),
      new google.maps.LatLng(56.927836, 24.139299),
      new google.maps.LatLng(56.914747, 24.158982),
      new google.maps.LatLng(56.900244, 24.18517),
      new google.maps.LatLng(56.894131, 24.191565),
      new google.maps.LatLng(56.881706, 24.207358),
      new google.maps.LatLng(56.874408, 24.227735),
      new google.maps.LatLng(56.865542, 24.249021),
    ];

    const aSection = new google.maps.Polygon({
      paths: regionA,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#97B022",
      fillOpacity: 0.4,
    });

    aSection.setMap(map);

    aSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "A",
        name: "Region A",
        fillColor: aSection.fillColor,
      });
    });

    aSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "A", name: "Region A" });
    });

    aSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "A", name: "Region A" });
    });

    GoogleMap.polygons["a"] = aSection;

    const regionB = [
      new google.maps.LatLng(56.975193, 24.088452),
      new google.maps.LatLng(56.970936, 24.078667),
      new google.maps.LatLng(56.977672, 24.058154),
      new google.maps.LatLng(56.982748, 24.00792),
      new google.maps.LatLng(56.983122, 23.99762),
      new google.maps.LatLng(56.980932, 23.990067),
      new google.maps.LatLng(56.971343, 24.011782),
      new google.maps.LatLng(56.955253, 23.973106),
      new google.maps.LatLng(56.949917, 23.970531),
      new google.maps.LatLng(56.947858, 23.988984),
      new google.maps.LatLng(56.944721, 23.993018),
      new google.maps.LatLng(56.927605, 23.95245),
      new google.maps.LatLng(56.914582, 23.968071),
      new google.maps.LatLng(56.911958, 23.975624),
      new google.maps.LatLng(56.9132, 23.988713),
      new google.maps.LatLng(56.909568, 23.988713),
      new google.maps.LatLng(56.907145, 23.986382),
      new google.maps.LatLng(56.895151, 23.979527),
      new google.maps.LatLng(56.882281, 23.986481),
      new google.maps.LatLng(56.876466, 23.991116),
      new google.maps.LatLng(56.88021, 24.010001),
      new google.maps.LatLng(56.880027, 24.035088),
      new google.maps.LatLng(56.875719, 24.06462),
      new google.maps.LatLng(56.880198, 24.094833),
      new google.maps.LatLng(56.87511, 24.098309),
      new google.maps.LatLng(56.868547, 24.094851),
      new google.maps.LatLng(56.861987, 24.107547),
      new google.maps.LatLng(56.853552, 24.13954),
      new google.maps.LatLng(56.845859, 24.154217),
      new google.maps.LatLng(56.829323, 24.155613),
      new google.maps.LatLng(56.823449, 24.188229),
      new google.maps.LatLng(56.810128, 24.194117),
      new google.maps.LatLng(56.795411, 24.222129),
      new google.maps.LatLng(56.791604, 24.241956),
      new google.maps.LatLng(56.794988, 24.25998),
      new google.maps.LatLng(56.800534, 24.268564),
      new google.maps.LatLng(56.812658, 24.271868),
      new google.maps.LatLng(56.818389, 24.294527),
      new google.maps.LatLng(56.824495, 24.275301),
      new google.maps.LatLng(56.842526, 24.265517),
      new google.maps.LatLng(56.847127, 24.266718),
      new google.maps.LatLng(56.851257, 24.272555),
      new google.maps.LatLng(56.866327, 24.247492),
      new google.maps.LatLng(56.87449, 24.227408),
      new google.maps.LatLng(56.881525, 24.207495),
      new google.maps.LatLng(56.89412, 24.191445),
      new google.maps.LatLng(56.900308, 24.184921),
      new google.maps.LatLng(56.914461, 24.159172),
      new google.maps.LatLng(56.927728, 24.139067),
      new google.maps.LatLng(56.938125, 24.117609),
      new google.maps.LatLng(56.945429, 24.099585),
      new google.maps.LatLng(56.955869, 24.092281),
      new google.maps.LatLng(56.96607, 24.086787),
      new google.maps.LatLng(56.975076, 24.088161),
      new google.maps.LatLng(56.970936, 24.078891),
    ];

    const bSection = new google.maps.Polygon({
      paths: regionB,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#C7BA0C",
      fillOpacity: 0.4,
    });

    bSection.setMap(map);

    bSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "B",
        name: "Region B",
        fillColor: bSection.fillColor,
      });
    });

    bSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "B", name: "Region B" });
    });

    bSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "B", name: "Region B" });
    });

    GoogleMap.polygons["b"] = bSection;

    const regionC = [
      new google.maps.LatLng(56.973233, 23.777182),
      new google.maps.LatLng(56.970566, 23.782589),
      new google.maps.LatLng(56.970332, 23.794948),
      new google.maps.LatLng(56.967993, 23.804819),
      new google.maps.LatLng(56.963922, 23.809025),
      new google.maps.LatLng(56.957979, 23.808424),
      new google.maps.LatLng(56.952503, 23.817951),
      new google.maps.LatLng(56.956856, 23.841211),
      new google.maps.LatLng(56.94932, 23.849108),
      new google.maps.LatLng(56.930452, 23.769655),
      new google.maps.LatLng(56.908468, 23.80112),
      new google.maps.LatLng(56.908421, 23.815497),
      new google.maps.LatLng(56.906124, 23.899354),
      new google.maps.LatLng(56.889961, 23.918938),
      new google.maps.LatLng(56.882036, 23.902372),
      new google.maps.LatLng(56.866089, 23.903059),
      new google.maps.LatLng(56.860787, 23.929752),
      new google.maps.LatLng(56.864139, 23.959259),
      new google.maps.LatLng(56.856913, 23.985523),
      new google.maps.LatLng(56.834871, 24.018334),
      new google.maps.LatLng(56.811864, 23.973252),
      new google.maps.LatLng(56.805802, 23.948362),
      new google.maps.LatLng(56.809984, 23.917382),
      new google.maps.LatLng(56.800586, 23.896182),
      new google.maps.LatLng(56.789543, 23.896835),
      new google.maps.LatLng(56.779575, 23.895462),
      new google.maps.LatLng(56.766705, 23.927674),
      new google.maps.LatLng(56.757736, 23.912976),
      new google.maps.LatLng(56.750018, 23.927739),
      new google.maps.LatLng(56.755854, 23.971684),
      new google.maps.LatLng(56.779185, 23.979237),
      new google.maps.LatLng(56.7884, 23.976834),
      new google.maps.LatLng(56.81559, 24.028896),
      new google.maps.LatLng(56.816906, 24.057735),
      new google.maps.LatLng(56.801494, 24.071468),
      new google.maps.LatLng(56.786829, 24.075245),
      new google.maps.LatLng(56.776108, 24.11507),
      new google.maps.LatLng(56.795478, 24.222187),
      new google.maps.LatLng(56.81014, 24.194034),
      new google.maps.LatLng(56.823482, 24.188198),
      new google.maps.LatLng(56.829305, 24.155582),
      new google.maps.LatLng(56.845832, 24.154209),
      new google.maps.LatLng(56.853529, 24.139446),
      new google.maps.LatLng(56.861976, 24.107517),
      new google.maps.LatLng(56.868544, 24.094814),
      new google.maps.LatLng(56.875111, 24.098247),
      new google.maps.LatLng(56.880176, 24.094814),
      new google.maps.LatLng(56.875674, 24.064602),
      new google.maps.LatLng(56.879989, 24.035076),
      new google.maps.LatLng(56.880176, 24.010013),
      new google.maps.LatLng(56.876425, 23.991131),
      new google.maps.LatLng(56.882427, 23.986324),
      new google.maps.LatLng(56.895181, 23.979458),
      new google.maps.LatLng(56.907179, 23.986324),
      new google.maps.LatLng(56.909616, 23.988727),
      new google.maps.LatLng(56.913178, 23.988727),
      new google.maps.LatLng(56.911866, 23.975681),
      new google.maps.LatLng(56.914489, 23.968128),
      new google.maps.LatLng(56.927606, 23.952335),
      new google.maps.LatLng(56.944839, 23.993019),
      new google.maps.LatLng(56.947835, 23.988899),
      new google.maps.LatLng(56.949894, 23.97036),
      new google.maps.LatLng(56.955324, 23.973106),
      new google.maps.LatLng(56.971369, 24.011807),
      new google.maps.LatLng(56.980911, 23.989834),
      new google.maps.LatLng(56.983156, 23.99773),
      new google.maps.LatLng(56.982782, 24.00803),
      new google.maps.LatLng(56.977731, 24.058203),
      new google.maps.LatLng(56.970994, 24.078803),
      new google.maps.LatLng(56.975298, 24.088416),
      new google.maps.LatLng(57.000597, 24.090819),
      new google.maps.LatLng(57.015553, 24.090132),
      new google.maps.LatLng(57.028073, 24.086356),
      new google.maps.LatLng(57.050302, 24.053397),
      new google.maps.LatLng(57.062064, 24.024558),
      new google.maps.LatLng(57.053476, 24.014601),
      new google.maps.LatLng(57.034799, 23.991256),
      new google.maps.LatLng(57.018169, 23.95658),
      new google.maps.LatLng(57.007702, 23.928427),
      new google.maps.LatLng(56.995548, 23.887915),
      new google.maps.LatLng(56.982081, 23.826804),
      new google.maps.LatLng(56.974834, 23.783474),
      new google.maps.LatLng(56.973138, 23.777402),
      new google.maps.LatLng(56.970565, 23.782637),
    ];

    // Construct the polygon.
    const cSection = new google.maps.Polygon({
      paths: regionC,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#BD9024",
      fillOpacity: 0.6,
    });

    cSection.setMap(map);

    cSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "C",
        name: "Region C",
        fillColor: cSection.fillColor,
      });
    });

    cSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "C", name: "Region C" });
    });

    cSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "C", name: "Region C" });
    });

    GoogleMap.polygons["c"] = cSection;

    const regionD = [
      new google.maps.LatLng(56.972011, 23.601554),
      new google.maps.LatLng(56.960829, 23.590911),
      new google.maps.LatLng(56.94177, 23.603214),
      new google.maps.LatLng(56.927113, 23.625936),
      new google.maps.LatLng(56.909879, 23.649254),
      new google.maps.LatLng(56.900889, 23.643787),
      new google.maps.LatLng(56.898287, 23.653314),
      new google.maps.LatLng(56.905377, 23.666984),
      new google.maps.LatLng(56.930476, 23.769445),
      new google.maps.LatLng(56.94936, 23.849055),
      new google.maps.LatLng(56.956849, 23.841072),
      new google.maps.LatLng(56.952403, 23.817812),
      new google.maps.LatLng(56.957926, 23.808285),
      new google.maps.LatLng(56.963869, 23.808886),
      new google.maps.LatLng(56.967981, 23.804509),
      new google.maps.LatLng(56.97018, 23.794896),
      new google.maps.LatLng(56.97046, 23.782536),
      new google.maps.LatLng(56.973174, 23.777043),
      new google.maps.LatLng(56.967305, 23.731104),
      new google.maps.LatLng(56.963001, 23.676797),
      new google.maps.LatLng(56.964064, 23.629733),
      new google.maps.LatLng(56.967807, 23.609305),
    ];

    const dSection = new google.maps.Polygon({
      paths: regionD,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#AA4318",
      fillOpacity: 0.4,
    });

    dSection.setMap(map);

    dSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "D",
        name: "Region D",
        fillColor: dSection.fillColor,
      });
    });

    dSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "D", name: "Region D" });
    });

    dSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "D", name: "Region D" });
    });

    GoogleMap.polygons["d"] = dSection;

    const regionH = [
      new google.maps.LatLng(56.83455662050065, 24.33489953842381),
      new google.maps.LatLng(56.826680463846394, 24.31810447164923),
      new google.maps.LatLng(56.81970650206665, 24.29923554665872),
      new google.maps.LatLng(56.81311167239663, 24.273136332824155),
      new google.maps.LatLng(56.80329498028006, 24.269031061457838),
      new google.maps.LatLng(56.79768895657868, 24.26493575553945),
      new google.maps.LatLng(56.793116961339486, 24.25314817091159),
      new google.maps.LatLng(56.79114143118041, 24.241563829075087),
      new google.maps.LatLng(56.79500836240069, 24.22155466775643),
      new google.maps.LatLng(56.78198763040128, 24.146854434892635),
      new google.maps.LatLng(56.775692777455774, 24.115359618387973),
      new google.maps.LatLng(56.780622931438586, 24.096662797390927),
      new google.maps.LatLng(56.7866261560933, 24.07569003247325),
      new google.maps.LatLng(56.79252494101299, 24.074178481848552),
      new google.maps.LatLng(56.80080237278546, 24.072855875051943),
      new google.maps.LatLng(56.80721612571656, 24.066242841068892),
      new google.maps.LatLng(56.817144933171164, 24.058307200289235),
      new google.maps.LatLng(56.81683469775474, 24.04451430083887),
      new google.maps.LatLng(56.816317633019146, 24.032044008185114),
      new google.maps.LatLng(56.81461323932106, 24.026046347845778),
      new google.maps.LatLng(56.7893086934632, 23.976617996653093),
      new google.maps.LatLng(56.780621295772804, 23.979587974472807),
      new google.maps.LatLng(56.769283799212346, 23.976074315982416),
      new google.maps.LatLng(56.75623074246908, 23.971779844494154),
      new google.maps.LatLng(56.750023599303766, 23.927273503615847),
      new google.maps.LatLng(56.7575148509187, 23.912438056656413),
      new google.maps.LatLng(56.76628841691808, 23.92610228411905),
      new google.maps.LatLng(56.76115291975704, 23.912047650157476),
      new google.maps.LatLng(56.750879817968226, 23.896040983701244),
      new google.maps.LatLng(56.743815430309255, 23.88315756923647),
      new google.maps.LatLng(56.735832764328556, 23.871263396191416),
      new google.maps.LatLng(56.73162737194494, 23.864585991936803),
      new google.maps.LatLng(56.72748934927404, 23.858774177122598),
      new google.maps.LatLng(56.72382580157784, 23.85469354118922),
      new google.maps.LatLng(56.719211937427346, 23.85024193835281),
      new google.maps.LatLng(56.71507254819444, 23.847026891859844),
      new google.maps.LatLng(56.71038973912368, 23.84282260029209),
      new google.maps.LatLng(56.704830391050315, 23.838260821859233),
      new google.maps.LatLng(56.70906664469376, 23.853776777305992),
      new google.maps.LatLng(56.71329670244491, 23.870346812012865),
      new google.maps.LatLng(56.717526284579925, 23.890770343163208),
      new google.maps.LatLng(56.720698159076406, 23.90541362964835),
      new google.maps.LatLng(56.725735897258915, 23.923640956169898),
      new google.maps.LatLng(56.72837909381241, 23.951130925906735),
      new google.maps.LatLng(56.730089298446366, 23.97975450264304),
      new google.maps.LatLng(56.73148849891711, 24.00611086538042),
      new google.maps.LatLng(56.73164396242136, 24.039268870114537),
      new google.maps.LatLng(56.72340351068645, 24.05627297510643),
      new google.maps.LatLng(56.724336482676726, 24.08461315009286),
      new google.maps.LatLng(56.72589138455302, 24.115503940828066),
      new google.maps.LatLng(56.72713525975822, 24.144127517564357),
      new google.maps.LatLng(56.72791266086443, 24.161981827805807),
      new google.maps.LatLng(56.72806813915672, 24.178985932797666),
      new google.maps.LatLng(56.71982690360663, 24.18408716429522),
      new google.maps.LatLng(56.71536243118578, 24.19574041372014),
      new google.maps.LatLng(56.71667913824897, 24.214934775748233),
      new google.maps.LatLng(56.717995799219494, 24.22613148693129),
      new google.maps.LatLng(56.718873547593276, 24.234928902860833),
      new google.maps.LatLng(56.71580133866165, 24.245325848959382),
      new google.maps.LatLng(56.71404567802899, 24.254123264888925),
      new google.maps.LatLng(56.70833921502357, 24.26691950624099),
      new google.maps.LatLng(56.70394903906406, 24.27891598250854),
      new google.maps.LatLng(56.690336238157535, 24.282115042846552),
      new google.maps.LatLng(56.683308350047334, 24.30610799538167),
      new google.maps.LatLng(56.68111186600998, 24.329301182832282),
      new google.maps.LatLng(56.692093005241794, 24.343696954353355),
      new google.maps.LatLng(56.701753758996695, 24.357292960789913),
      new google.maps.LatLng(56.70570517091468, 24.369289437057475),
      new google.maps.LatLng(56.71185098700169, 24.382085678409535),
      new google.maps.LatLng(56.72106782890665, 24.3948819197616),
      new google.maps.LatLng(56.73159859715433, 24.398880745184112),
      new google.maps.LatLng(56.73774018328196, 24.407678161113658),
      new google.maps.LatLng(56.735985546787916, 24.422073932634724),
      new google.maps.LatLng(56.73686287527462, 24.432470878733277),
      new google.maps.LatLng(56.74124921052306, 24.438069234324804),
      new google.maps.LatLng(56.74388076593386, 24.45006571059236),
      new google.maps.LatLng(56.745309479713534, 24.456803126377228),
      new google.maps.LatLng(56.74696034460717, 24.45976811743826),
      new google.maps.LatLng(56.75045884818761, 24.45166524076137),
      new google.maps.LatLng(56.75352822575245, 24.43886899940931),
      new google.maps.LatLng(56.761652654508325, 24.441620609311737),
      new google.maps.LatLng(56.76759680577528, 24.44564390770821),
      new google.maps.LatLng(56.776321465166006, 24.447666415338848),
      new google.maps.LatLng(56.78245574239693, 24.4596628916064),
      new google.maps.LatLng(56.79384531113653, 24.46606101228243),
      new google.maps.LatLng(56.80260416473946, 24.462062186859914),
      new google.maps.LatLng(56.813112088511424, 24.456463831268387),
      new google.maps.LatLng(56.82099109825795, 24.4596628916064),
      new google.maps.LatLng(56.8239889898728, 24.45860667838245),
      new google.maps.LatLng(56.82628891935681, 24.45788583823397),
      new google.maps.LatLng(56.82602321037329, 24.449792571769347),
      new google.maps.LatLng(56.82885734235454, 24.433282308181532),
      new google.maps.LatLng(56.831956928657036, 24.423408523094686),
      new google.maps.LatLng(56.8301857678974, 24.40932623944623),
      new google.maps.LatLng(56.830008647214186, 24.387798150650315),
      new google.maps.LatLng(56.83186837260853, 24.361575967304937),
      new google.maps.LatLng(56.835539385915546, 24.34318099525131),
      new google.maps.LatLng(56.834565634262894, 24.334939290370432),
    ];

    const hSection = new google.maps.Polygon({
      paths: regionH,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#AA4318",
      fillOpacity: 0.4,
    });

    hSection.setMap(map);

    hSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "D",
        name: "Region D",
        fillColor: hSection.fillColor,
      });
    });

    hSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "D", name: "Region D" });
    });

    hSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "D", name: "Region D" });
    });

    GoogleMap.polygons["d2"] = hSection;

    const regionE = [
      new google.maps.LatLng(56.972011, 23.601554),
      new google.maps.LatLng(56.975025, 23.564382),
      new google.maps.LatLng(56.979515, 23.552023),
      new google.maps.LatLng(56.974276, 23.532797),
      new google.maps.LatLng(56.966042, 23.498464),
      new google.maps.LatLng(56.964545, 23.480612),
      new google.maps.LatLng(56.956309, 23.484388),
      new google.maps.LatLng(56.949943, 23.483015),
      new google.maps.LatLng(56.946573, 23.473402),
      new google.maps.LatLng(56.931215, 23.481642),
      new google.maps.LatLng(56.92522, 23.52696),
      new google.maps.LatLng(56.922597, 23.586698),
      new google.maps.LatLng(56.919598, 23.601118),
      new google.maps.LatLng(56.9166, 23.616911),
      new google.maps.LatLng(56.900105, 23.625837),
      new google.maps.LatLng(56.888854, 23.616224),
      new google.maps.LatLng(56.884727, 23.598371),
      new google.maps.LatLng(56.87835, 23.595625),
      new google.maps.LatLng(56.869344, 23.601118),
      new google.maps.LatLng(56.855456, 23.582578),
      new google.maps.LatLng(56.845318, 23.566786),
      new google.maps.LatLng(56.814136, 23.581892),
      new google.maps.LatLng(56.804739, 23.599745),
      new google.maps.LatLng(56.7991, 23.619657),
      new google.maps.LatLng(56.747177, 23.656736),
      new google.maps.LatLng(56.729853, 23.675276),
      new google.maps.LatLng(56.705361, 23.681455),
      new google.maps.LatLng(56.691482, 23.714414),
      new google.maps.LatLng(56.686203, 23.708921),
      new google.maps.LatLng(56.676774, 23.685575),
      new google.maps.LatLng(56.67451, 23.665663),
      new google.maps.LatLng(56.653379, 23.646436),
      new google.maps.LatLng(56.620527, 23.686949),
      new google.maps.LatLng(56.615237, 23.724027),
      new google.maps.LatLng(56.626948, 23.743253),
      new google.maps.LatLng(56.622415, 23.772093),
      new google.maps.LatLng(56.642054, 23.811918),
      new google.maps.LatLng(56.646207, 23.824278),
      new google.maps.LatLng(56.658663, 23.814665),
      new google.maps.LatLng(56.667719, 23.824278),
      new google.maps.LatLng(56.687711, 23.823591),
      new google.maps.LatLng(56.727287, 23.85861),
      new google.maps.LatLng(56.760423, 23.910795),
      new google.maps.LatLng(56.766705, 23.927674),
      new google.maps.LatLng(56.779575, 23.895462),
      new google.maps.LatLng(56.789543, 23.896835),
      new google.maps.LatLng(56.800586, 23.896182),
      new google.maps.LatLng(56.809984, 23.917382),
      new google.maps.LatLng(56.805802, 23.948362),
      new google.maps.LatLng(56.811864, 23.973252),
      new google.maps.LatLng(56.834871, 24.018334),
      new google.maps.LatLng(56.856913, 23.985523),
      new google.maps.LatLng(56.864139, 23.959259),
      new google.maps.LatLng(56.860787, 23.929752),
      new google.maps.LatLng(56.866089, 23.903059),
      new google.maps.LatLng(56.882036, 23.902372),
      new google.maps.LatLng(56.889961, 23.918938),
      new google.maps.LatLng(56.906124, 23.899354),
      new google.maps.LatLng(56.908421, 23.815497),
      new google.maps.LatLng(56.908468, 23.80112),
      new google.maps.LatLng(56.930452, 23.769655),
      new google.maps.LatLng(56.905377, 23.666984),
      new google.maps.LatLng(56.898287, 23.653314),
      new google.maps.LatLng(56.900889, 23.643787),
      new google.maps.LatLng(56.909879, 23.649254),
      new google.maps.LatLng(56.94177, 23.603214),
      new google.maps.LatLng(56.960829, 23.590911),
      new google.maps.LatLng(56.960829, 23.590911),
    ];

    // Construct the polygon.
    const eSection = new google.maps.Polygon({
      paths: regionE,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#C7710C",
      fillOpacity: 0.4,
    });

    eSection.setMap(map);

    eSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "E",
        name: "Region E",
        fillColor: eSection.fillColor,
      });
    });

    eSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "E", name: "Region E" });
    });

    eSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "E", name: "Region E" });
    });

    GoogleMap.polygons["e"] = eSection;

    const regionF = [
      new google.maps.LatLng(57.050357, 24.053471),
      new google.maps.LatLng(57.028176, 24.086345),
      new google.maps.LatLng(57.029624, 24.089091),
      new google.maps.LatLng(57.023411, 24.113124),
      new google.maps.LatLng(57.024112, 24.122737),
      new google.maps.LatLng(57.03308, 24.137929),
      new google.maps.LatLng(57.035695, 24.118789),
      new google.maps.LatLng(57.043541, 24.116299),
      new google.maps.LatLng(57.054698, 24.127887),
      new google.maps.LatLng(57.055546, 24.152624),
      new google.maps.LatLng(57.073699, 24.225924),
      new google.maps.LatLng(57.066513, 24.233906),
      new google.maps.LatLng(57.06796, 24.242778),
      new google.maps.LatLng(57.041836, 24.250232),
      new google.maps.LatLng(57.038474, 24.271132),
      new google.maps.LatLng(57.049022, 24.313674),
      new google.maps.LatLng(57.05306, 24.317708),
      new google.maps.LatLng(57.081977, 24.29615),
      new google.maps.LatLng(57.098127, 24.303793),
      new google.maps.LatLng(57.102579, 24.327825),
      new google.maps.LatLng(57.096022, 24.331662),
      new google.maps.LatLng(57.086691, 24.325153),
      new google.maps.LatLng(57.081689, 24.336397),
      new google.maps.LatLng(57.084651, 24.34528),
      new google.maps.LatLng(57.077743, 24.374525),
      new google.maps.LatLng(57.069916, 24.377637),
      new google.maps.LatLng(57.06882, 24.381349),
      new google.maps.LatLng(57.073453, 24.38512),
      new google.maps.LatLng(57.077027, 24.394072),
      new google.maps.LatLng(57.077005, 24.412643),
      new google.maps.LatLng(57.08129, 24.438141),
      new google.maps.LatLng(57.064541, 24.459942),
      new google.maps.LatLng(57.042954, 24.469796),
      new google.maps.LatLng(57.070306, 24.566527),
      new google.maps.LatLng(57.086913, 24.585067),
      new google.maps.LatLng(57.098164, 24.573394),
      new google.maps.LatLng(57.108979, 24.508849),
      new google.maps.LatLng(57.111962, 24.45941),
      new google.maps.LatLng(57.116809, 24.405165),
      new google.maps.LatLng(57.127246, 24.37152),
      new google.maps.LatLng(57.177153, 24.382506),
      new google.maps.LatLng(57.204313, 24.392806),
      new google.maps.LatLng(57.211954, 24.364473),
      new google.maps.LatLng(57.187032, 24.323275),
      new google.maps.LatLng(57.15986, 24.26491),
      new google.maps.LatLng(57.140119, 24.236071),
      new google.maps.LatLng(57.112166, 24.183199),
      new google.maps.LatLng(57.086431, 24.118654),
      new google.maps.LatLng(57.073973, 24.076875),
      new google.maps.LatLng(57.064454, 24.028123),
      new google.maps.LatLng(57.062214, 24.025034),
    ];

    // Construct the polygon.
    const fSection = new google.maps.Polygon({
      paths: regionF,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#C7710C",
      fillOpacity: 0.4,
    });

    fSection.setMap(map);

    fSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "E",
        name: "Region E",
        fillColor: fSection.fillColor,
      });
    });

    fSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "E", name: "Region E" });
    });

    fSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "E", name: "Region E" });
    });

    GoogleMap.polygons["e2"] = fSection;

    const regionG = [
      new google.maps.LatLng(56.842856, 24.38968),
      new google.maps.LatLng(56.840133, 24.406159),
      new google.maps.LatLng(56.845484, 24.420235),
      new google.maps.LatLng(56.840227, 24.427273),
      new google.maps.LatLng(56.844545, 24.443066),
      new google.maps.LatLng(56.839757, 24.465211),
      new google.maps.LatLng(56.822852, 24.495251),
      new google.maps.LatLng(56.815336, 24.513791),
      new google.maps.LatLng(56.812517, 24.53954),
      new google.maps.LatLng(56.818061, 24.559968),
      new google.maps.LatLng(56.816182, 24.571641),
      new google.maps.LatLng(56.797762, 24.609406),
      new google.maps.LatLng(56.788173, 24.615243),
      new google.maps.LatLng(56.792874, 24.638932),
      new google.maps.LatLng(56.79513, 24.653351),
      new google.maps.LatLng(56.806221, 24.651978),
      new google.maps.LatLng(56.812236, 24.664681),
      new google.maps.LatLng(56.81543, 24.686654),
      new google.maps.LatLng(56.822382, 24.692834),
      new google.maps.LatLng(56.82614, 24.662278),
      new google.maps.LatLng(56.831587, 24.648888),
      new google.maps.LatLng(56.827643, 24.623482),
      new google.maps.LatLng(56.836846, 24.58194),
      new google.maps.LatLng(56.861628, 24.565804),
      new google.maps.LatLng(56.868907, 24.573222),
      new google.maps.LatLng(56.882978, 24.569789),
      new google.maps.LatLng(56.891793, 24.573909),
      new google.maps.LatLng(56.899293, 24.591418),
      new google.maps.LatLng(56.906417, 24.606181),
      new google.maps.LatLng(56.921411, 24.625064),
      new google.maps.LatLng(56.934396, 24.629219),
      new google.maps.LatLng(56.940015, 24.6148),
      new google.maps.LatLng(56.944322, 24.619949),
      new google.maps.LatLng(56.951812, 24.614456),
      new google.maps.LatLng(56.969782, 24.636086),
      new google.maps.LatLng(56.983, 24.63551),
      new google.maps.LatLng(56.984496, 24.626927),
      new google.maps.LatLng(56.98618, 24.603924),
      new google.maps.LatLng(56.997776, 24.586415),
      new google.maps.LatLng(57.009181, 24.56793),
      new google.maps.LatLng(57.011611, 24.560377),
      new google.maps.LatLng(57.017405, 24.540808),
      new google.maps.LatLng(57.017218, 24.523298),
      new google.maps.LatLng(57.010489, 24.497549),
      new google.maps.LatLng(57.01348, 24.46974),
      new google.maps.LatLng(57.017405, 24.447424),
      new google.maps.LatLng(57.029178, 24.459097),
      new google.maps.LatLng(57.043002, 24.46974),
      new google.maps.LatLng(57.064661, 24.459784),
      new google.maps.LatLng(57.08127, 24.438024),
      new google.maps.LatLng(57.076978, 24.412618),
      new google.maps.LatLng(57.076978, 24.394079),
      new google.maps.LatLng(57.073433, 24.385152),
      new google.maps.LatLng(57.068767, 24.381376),
      new google.maps.LatLng(57.069887, 24.377599),
      new google.maps.LatLng(57.077725, 24.374509),
      new google.maps.LatLng(57.084628, 24.345327),
      new google.maps.LatLng(57.081643, 24.336401),
      new google.maps.LatLng(57.08668, 24.325071),
      new google.maps.LatLng(57.096007, 24.331594),
      new google.maps.LatLng(57.102534, 24.327818),
      new google.maps.LatLng(57.098058, 24.303785),
      new google.maps.LatLng(57.082016, 24.296232),
      new google.maps.LatLng(57.060927, 24.311681),
      new google.maps.LatLng(57.053086, 24.317861),
      new google.maps.LatLng(57.048978, 24.313741),
      new google.maps.LatLng(57.044309, 24.294859),
      new google.maps.LatLng(57.038409, 24.271169),
      new google.maps.LatLng(57.041771, 24.250227),
      new google.maps.LatLng(57.068097, 24.242674),
      new google.maps.LatLng(57.066417, 24.233747),
      new google.maps.LatLng(57.073696, 24.225851),
      new google.maps.LatLng(57.055403, 24.15238),
      new google.maps.LatLng(57.054656, 24.12766),
      new google.maps.LatLng(57.043639, 24.116331),
      new google.maps.LatLng(57.035794, 24.118734),
      new google.maps.LatLng(57.033225, 24.137703),
      new google.maps.LatLng(57.025658, 24.154182),
      new google.maps.LatLng(57.017248, 24.160979),
      new google.maps.LatLng(57.010566, 24.161408),
      new google.maps.LatLng(57.007108, 24.173768),
      new google.maps.LatLng(57.002387, 24.178489),
      new google.maps.LatLng(56.998205, 24.175691),
      new google.maps.LatLng(56.996101, 24.196205),
      new google.maps.LatLng(56.998906, 24.219379),
      new google.maps.LatLng(56.995821, 24.23131),
      new google.maps.LatLng(56.996242, 24.245722),
      new google.maps.LatLng(56.993016, 24.252589),
      new google.maps.LatLng(57.00926, 24.309024),
      new google.maps.LatLng(56.99654, 24.307941),
      new google.maps.LatLng(56.987509, 24.316612),
      new google.maps.LatLng(56.972085, 24.343868),
      new google.maps.LatLng(56.965468, 24.366053),
      new google.maps.LatLng(56.958831, 24.377939),
      new google.maps.LatLng(56.952415, 24.377268),
      new google.maps.LatLng(56.921304, 24.393648),
      new google.maps.LatLng(56.906954, 24.406453),
      new google.maps.LatLng(56.890301, 24.406529),
      new google.maps.LatLng(56.878267, 24.40668),
      new google.maps.LatLng(56.865928, 24.406805),
      new google.maps.LatLng(56.852344, 24.400325),
      new google.maps.LatLng(56.842753, 24.389738),
      new google.maps.LatLng(56.842847, 24.391626),
      new google.maps.LatLng(56.840781, 24.396089),
      new google.maps.LatLng(56.839655, 24.402656),
      new google.maps.LatLng(56.840195, 24.406518),
      new google.maps.LatLng(56.843316, 24.411796),
      new google.maps.LatLng(56.843152, 24.413599),
      new google.maps.LatLng(56.84564, 24.416775),
    ];

    // Construct the polygon.
    const gSection = new google.maps.Polygon({
      paths: regionG,
      strokeColor: "#E8E8E8",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#C7BA0C",
      fillOpacity: 0.4,
    });

    gSection.setMap(map);

    gSection.addListener("click", (event) => {
      GoogleMap.onPolygonClick(event, {
        id: "B",
        name: "Region B",
        fillColor: gSection.fillColor,
      });
    });

    gSection.addListener("mouseover", (event) => {
      GoogleMap.onPolygonHover(event, { id: "B", name: "Region B" });
    });

    gSection.addListener("mouseout", (event) => {
      GoogleMap.onPolygonHoverEnd(event, { id: "B", name: "Region B" });
    });

    GoogleMap.polygons["b2"] = gSection;

    const autocompleteInput = document.getElementById("address-autocomplete");
    if (autocompleteInput) {
      const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, {
        componentRestrictions: { country: "lv" },
        fields: ["geometry", "formatted_address", "name"],
        types: [],
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const msgWrapper = document.getElementById("region-message");
        const msgNotFound = msgWrapper.querySelector('p[data-message="not-found"]');
        const msgInvalid = msgWrapper.querySelector('p[data-message="invalid"]');

        // Hide both messages initially
        msgNotFound.style.display = "none";
        msgInvalid.style.display = "none";
        msgWrapper.style.display = "none";

        if (!place.geometry || !place.geometry.location) {
          msgInvalid.style.display = "block";
          msgWrapper.style.display = "block";
          document.querySelectorAll('input[name="region-pricing"]').forEach((radio) => {
            radio.checked = false;
          });
          document.querySelectorAll(".regionPricing__option").forEach((el) =>
            el.classList.remove("selected")
          );
          return;
        }

        const location = place.geometry.location;
        map.panTo(location);

        let matchedRegion = null;
        for (const [key, polygon] of Object.entries(GoogleMap.polygons)) {
          if (google.maps.geometry.poly.containsLocation(location, polygon)) {
            matchedRegion = key;
            google.maps.event.trigger(polygon, "click", { latLng: location });
            break;
          }
        }

        if (!matchedRegion) {
          msgNotFound.style.display = "block";
          msgWrapper.style.display = "block";
          document.querySelectorAll('input[name="region-pricing"]').forEach((radio) => {
            radio.checked = false;
          });
          document.querySelectorAll(".regionPricing__option").forEach((el) =>
            el.classList.remove("selected")
          );
        }
      });

    }


    // Map created.
    document.body.dispatchEvent(Rent.mapEvent);
  },

  addMarker(position, map) {
    const icon = {
      url:
        window.location.origin +
        "/themes/base/resources/src/img/" +
        position.name +
        "zone.svg",
      size: new GoogleMap.library.Size(30, 35),
    };

    // Define hover icon
    const hoverIcon = {
      url:
        window.location.origin +
        "/themes/base/resources/src/img/" +
        position.name +
        "zoneactive.svg",
      size: new GoogleMap.library.Size(30, 35),
    };

    const marker_options = {
      position,
      optimized: false,
      map,
      icon,
      isActive: false,
      zone: position.name,
      animation: GoogleMap.library.Animation.DROP,
    };

    const marker = new GoogleMap.library.Marker(marker_options);

    // Associate the marker with the polygon.
    marker.addListener("click", (event) => {
      let associatedPolygon = GoogleMap.polygons[position.name];
      google.maps.event.trigger(associatedPolygon, "click", event);
    });

    // Add event listeners for hover effect
    marker.addListener("mouseover", function (event) {
      if (!marker.isActive) {
        marker.setIcon(hoverIcon);
      }

      let associatedPolygon = GoogleMap.polygons[position.name];
      google.maps.event.trigger(associatedPolygon, "mouseover", event);
    });

    marker.addListener("mouseout", function () {
      if (!marker.isActive) {
        marker.setIcon(icon);
      }
    });

    Tabs.polygons = GoogleMap.polygons;

    return marker;
  },

  styles: [
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{ color: "#ffffff" }, { lightness: 17 }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }, { lightness: 18 }],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }, { lightness: 16 }],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#dedede" }, { lightness: 21 }],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }],
    },
    {
      elementType: "labels.text.fill",
      stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }],
    },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [{ color: "#fefefe" }, { lightness: 20 }],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
    },
  ],

  onPolygonHover(event, polygonData) {
    Tabs.handlePolygonHover(polygonData.id);
    GoogleMap.setActiveMarker(polygonData.id);
  },

  onPolygonHoverEnd(event, polygonData) {
    Tabs.handlePolygonHoverEnd(polygonData.id);
  },

  onPolygonClick(event, polygonData) {
    // Sets the radio field to the clicked polygon
    Tabs.setActiveRegion(polygonData.id);
    Tabs.setActiveRegionStyle(polygonData.id, polygonData.fillColor);
    // Sets the active marker
    GoogleMap.setActiveMarker(polygonData.id);

    let selectedRegionPrice = Rent.selectedContainer.pricing[polygonData.id];
    Rent.updateTopBarPrice(selectedRegionPrice);

    // Updates form data
    Rent.updateFormData("region_price", selectedRegionPrice);
    Rent.updateFormData("selected_region", polygonData.id);

    $("#tab2 button.nextTab").removeClass("inactive");
  },

  setActiveMarker(region) {
    GoogleMap.markers.forEach((marker) => {
      if (marker.zone === region.toLowerCase()) {
        marker.isActive = true;
        marker.setIcon({
          url:
            window.location.origin +
            "/themes/base/resources/src/img/" +
            marker.zone +
            "zoneactive.svg",
          size: new GoogleMap.library.Size(30, 35),
        });
      } else {
        marker.setIcon({
          url:
            window.location.origin +
            "/themes/base/resources/src/img/" +
            marker.zone +
            "zone.svg",
          size: new GoogleMap.library.Size(30, 35),
        });
        marker.isActive = false;
      }
    });
  },
};

export default GoogleMap;
